import { useLoggedViewer } from "./use-logged-user";
import { useShopMembersSuspenseQuery } from "./use-shop-members-query";

/**
 * Returns the current user's shop-member record (role + warehouse/store
 * scope). Suspends until both the viewer and the members list are ready — no
 * flash of unrestricted UI before the role resolves.
 */
export function useCurrentShopMember(shopId: string) {
  const { data: viewer } = useLoggedViewer();
  const { data: members } = useShopMembersSuspenseQuery(shopId);

  const member = viewer?.id
    ? members.find((m) => m.userId === viewer.id) ?? null
    : null;

  return { member };
}
